// extracted by mini-css-extract-plugin
var _1 = "iETyfaug084LaI91AtzS";
export { _1 as "control" }
